/* eslint-disable react/no-unknown-property */

import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import type React from 'react';
import { type MouseEventHandler, useState } from 'react';
import { THUMBNAIL_OFFLINE } from 'src/constants';
import BlackSquareCanvas from 'src/HomePage/DrawerAndPushedContents/PushedContents/AkomiMediaCardGrid/AkomiMediaCard/BlackSquarePlaceHolder';
import MediaUnavailable from 'src/HomePage/DrawerAndPushedContents/PushedContents/AkomiMediaCardGrid/AkomiMediaCard/MediaUnavailable';
import { BoxImageStyles, ImageWrapperStyles } from '../CommonStyles/ImageDiv/ImageDivStyles';

const useStyles = makeStyles(() => ({
  imagesContainer: {
    margin: 'auto',
    position: 'relative',
    paddingTop: '56.25%',
  },
  boxImages: {
    objectFit: 'contain',
    width: '100%',
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
  },
  modalImage: {
    height: '100%',
    width: '100%',
  },
  closeIcon: {
    position: 'fixed',
    top: 10,
    right: 10,
    zIndex: 12002,
  },
  container: {
    backgroundColor: 'green',
  },
  mainSection: {
    display: 'flex',
    justifyContent: 'center',
  },
  tools: {
    opacity: 0.5,
    backgroundColor: 'rgba(0,0,0,0.75)',
    position: 'absolute',
    bottom: 20,
    zIndex: 1,
    display: 'flex',
    justifyContent: 'center',
    '&:hover': {
      opacity: 1,
    },
  },
}));

interface ImageBoxProps {
  imageBoxFormat?: string;
  className?: string;
  name?: string;
  onClickHandler?: MouseEventHandler<HTMLButtonElement | HTMLDivElement | HTMLImageElement>;
  unavailableText?: string;
}

const ImageBox: React.FC<ImageBoxProps> = ({ imageBoxFormat, ...props }) => {
  const classes = useStyles();
  const [cannotLoad, setCannotLoad] = useState<boolean>(false);

  if (!imageBoxFormat)
    return (
      <ImageWrapperStyles>
        <BoxImageStyles>
          <BlackSquareCanvas />
        </BoxImageStyles>
      </ImageWrapperStyles>
    );

  if (cannotLoad)
    return (
      <ImageWrapperStyles>
        <BoxImageStyles>
          <MediaUnavailable text={props.unavailableText ?? THUMBNAIL_OFFLINE} />
        </BoxImageStyles>
      </ImageWrapperStyles>
    );

  if (props.onClickHandler) {
    return (
      <button
        type="button"
        className={clsx(classes.imagesContainer, props.className ? props.className : '')}
        onClick={props.onClickHandler}
        style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          width: '100%',
          display: 'block',
          paddingLeft: 0,
          paddingRight: 0,
          paddingBottom: 0,
        }}
      >
        <img onError={() => setCannotLoad(true)} className={classes.boxImages} src={imageBoxFormat} alt={props.name} />
      </button>
    );
  }

  return (
    <div className={clsx(classes.imagesContainer, props.className ? props.className : '')}>
      <img onError={() => setCannotLoad(true)} className={classes.boxImages} src={imageBoxFormat} alt={props.name} />
    </div>
  );
};

export default ImageBox;
